import React, { useEffect, useState, useCallback, useContext } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { Tab, TabList } from '@fluentui/react-components';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import {
//   AdsStudioSpinner,
  ClarityTags,
  useClarityTags
} from '@bingads-webui-campaign-react/ads-studio-app-shared-components';
// import { Overlay } from '@bingads-webui-react/fabric-control';

import { actionTypes } from './reducer';
import { BrandVoice } from './brand-voice';
import { useBrandKitPageStyle } from './styles';
import { BrandElements } from './brand-elements';
import { BrandKitPageBanner } from './components';
import { withBrandKitContext, BrandKitContext } from './context';

const TabValues = {
  Assets: 'assets',
  BrandVoice: 'brandVoice',
};

const BrandKitPage = ({
  brandKitDataService,
  imageEditService,
  notificationApi,
  // brandkitApiState,
  logger,
  permissions,
  aid,
  perfMarker,
  pagePerfMarker: brandKitPagePerfMarker,
  setDataLoaded,
  ...rest
}) => {
  const classes = useBrandKitPageStyle();
  const i18n = useContext(I18nContext);
  const [loading, setLoading] = useState(true);
  const { dispatch } = useContext(BrandKitContext);

  const [selectedTab, setSelectedTab] = useState(TabValues.Assets);

  const onTabSelect = useCallback((_e, data) => {
    setSelectedTab(data.value);
  }, []);

  const onFailedToLoadData = useCallback(() => {
    notificationApi.showWarning(i18n.getString(_TL_('Failed to load. Please refresh the page and try again.')));
  }, [i18n, notificationApi]);

  const fetchBrandKitData = useCallback(async () => {
    brandKitPagePerfMarker.willFetchData();
    const { response, error } = await brandKitDataService.getBrandKits(aid);
    if (error) {
      onFailedToLoadData();
      setLoading(false);
      logger.logTrace('failed to load');
      if (brandKitPagePerfMarker && setDataLoaded) {
        brandKitPagePerfMarker.willRender();
        setDataLoaded();
      }
      return;
    }
    dispatch({
      type: actionTypes.setData,
      payload: response[0] || {},
    });
    setLoading(false);
    if (brandKitPagePerfMarker && setDataLoaded) {
      brandKitPagePerfMarker.willRender();
      setDataLoaded();
    }
  }, [brandKitDataService, onFailedToLoadData, logger, dispatch, aid]);
  useEffect(() => {
    fetchBrandKitData();
  }, [fetchBrandKitData]);

  useClarityTags([
    ClarityTags.BrandKitPage,
    ClarityTags.LaunchedAdsStudio,
  ]);

  const isBrandKitUIPhase2Enabled = permissions && permissions.dynamic && permissions.dynamic.BrandKitUIPhase2;
  const isBrandKitUIPhase3Enabled = permissions && permissions.dynamic && permissions.dynamic.BrandKitUIPhase3;

  return (
    <div className={classnames('ads-studio-brand-kit-page', classes.brandKitPage)}>
      <BrandKitPageBanner i18n={i18n} hideActionsMenu={!isBrandKitUIPhase2Enabled} />
      {/* {(brandkitApiState && brandkitApiState.brandkitLoading) && (
        <Overlay>
          <AdsStudioSpinner className="page-load-spinner" useCustomSize customStyle={{ margin: 250 }} />
        </Overlay>
      )} */}
      {isBrandKitUIPhase3Enabled && (
      <TabList selectedValue={selectedTab} onTabSelect={onTabSelect}>
        <Tab value={TabValues.Assets}>{i18n.getString(_TL_('Assets'))}</Tab>
        <Tab value={TabValues.BrandVoice}>{i18n.getString(_TL_('Brand voice'))}</Tab>
      </TabList>
     )}
      {selectedTab === TabValues.Assets && <BrandElements
        loading={loading}
        aid={aid}
        fetchBrandKitData={fetchBrandKitData}
        brandKitDataService={brandKitDataService}
        logger={logger}
        imageEditService={imageEditService}
        i18n={i18n}
        permissions={permissions}
        perfMarker={perfMarker}
        {...rest}
      />}
      {selectedTab === TabValues.BrandVoice && <BrandVoice brandKitDataService={brandKitDataService} />}
    </div>
  );
};

BrandKitPage.propTypes = {
  notificationApi: PropTypes.shape({}),
  logger: PropTypes.shape({
    logTrace: PropTypes.func,
  }).isRequired,
  brandKitDataService: PropTypes.shape({
    getBrandKits: PropTypes.func,
    createBrandKits: PropTypes.func,
    updateBrandKit: PropTypes.func,
    brandkitLoading: PropTypes.bool,
  }).isRequired,
  brandkitApiState: PropTypes.shape({
    brandkitResp: PropTypes.shape({}),
    brandkitError: PropTypes.shape({}),
    cache: PropTypes.shape({}),
    brandkitLoading: PropTypes.bool,
  }).isRequired,
  aid: PropTypes.number.isRequired,
  imageEditService: PropTypes.shape({}).isRequired,
  permissions: PropTypes.shape({
    dynamic: PropTypes.shape({
      BrandKitUIPhase2: PropTypes.bool,
    }).isRequired,
  }).isRequired,
  perfMarker: PropTypes.shape({}).isRequired,
};

BrandKitPage.defaultProps = {
  notificationApi: {
    showWarning: () => {},
  },
};

export const BrandKitPageComponent = withBrandKitContext(BrandKitPage);
